module.exports = __webpack_public_path__ + "static/assets/30f241498044906f71dc92bbc1f328f0.svg";